// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesListHeaderStyles } from "@conklin/Overrides/Components/CartLinesListHeader";
import IconEdit from "@conklin/XDL/Icons/IconEdit";
import { createLinkIconStyles } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

cartLinesListHeaderStyles.wrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        margin-bottom: 12px;
        column-gap: 32px;
    `,
};

cartLinesListHeaderStyles.productCountText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

cartLinesListHeaderStyles.editCartLink = {
    ...createLinkIconStyles(IconEdit, "small"),
};
